"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OrderStatus = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _customer = require("@/api/customer");
var _staff = require("@/api/staff");
var _vuePropertyDecorator = require("vue-property-decorator");
var FilterOrder = /*#__PURE__*/function (_Vue) {
  function FilterOrder() {
    var _this;
    (0, _classCallCheck2.default)(this, FilterOrder);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, FilterOrder, [].concat(args));
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "staffs", []);
    (0, _defineProperty2.default)(_this, "customers", []);
    (0, _defineProperty2.default)(_this, "OrderStatus", OrderStatus);
    (0, _defineProperty2.default)(_this, "date", []);
    return _this;
  }
  (0, _inherits2.default)(FilterOrder, _Vue);
  return (0, _createClass2.default)(FilterOrder, [{
    key: "watchFormDate",
    value: function watchFormDate(date) {
      this.form.from = date[0];
      this.form.to = date[1];
    }
  }, {
    key: "handleApply",
    value: function handleApply() {
      this.visible = false;
      this.$emit("apply", this.form);
    }
  }, {
    key: "fetchCustomers",
    value: function fetchCustomers() {
      var _this2 = this;
      _customer.customerApi.findAll().then(function (res) {
        return _this2.customers = res.data.customers;
      });
    }
  }, {
    key: "fetchStaffs",
    value: function fetchStaffs() {
      var _this3 = this;
      _staff.staffApi.findAll().then(function (res) {
        return _this3.staffs = res.data.data;
      });
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchStaffs();
      this.fetchCustomers();
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      this.visible = true;
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("date", {
  deep: true
})], FilterOrder.prototype, "watchFormDate", null);
FilterOrder = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], FilterOrder);
var _default = exports.default = FilterOrder;
var OrderStatus;
(function (OrderStatus) {
  OrderStatus["Pending"] = "PENDING";
  OrderStatus["Processing"] = "PROCESSING";
  OrderStatus["Complete"] = "COMPLETE";
  OrderStatus["Cancel"] = "Cancel";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));